import styled from "styled-components";

export const SimpleTabs = styled.div`
  display: flex;
  column-gap: 15px;
  font-size: 14px;
  margin-bottom: -2px;
`;

export const Tab = styled.span`
  opacity: ${({ isSelected, isDisabled }) =>
    isSelected ? 1 : isDisabled ? 0.2 : 0.5};
  color: ${({ isSelected, theme }) => theme.text.title};
  border-bottom: ${({ isSelected, theme }) =>
    `2px solid ${isSelected ? theme.text.title : "transparent"}`};
  cursor: ${({ isDisabled }) => (isDisabled ? "initial" : "pointer")};
  user-select: none;
  padding-bottom: 6px;
`;
